import { TenantSelectionMessages, TranslationTenantSelectionMessages } from "../interfaces";

export const messages: TranslationTenantSelectionMessages = {
  [TenantSelectionMessages.title]: "Select the tenant you want to access",
  [TenantSelectionMessages.currentTenant]: "Current tenant: {{currentTenantName}}",
  [TenantSelectionMessages.confirmTenantSelectionModalTitle]: "Tenant change",
  [TenantSelectionMessages.confirmTenantSelectionModalContent]: "By confirming the selection of a new tenant,"
  + " you will be automatically logged out to apply the changes. Do you want to continue?"

};